<template>
    <div>
        <div :class="{ 'show': modalShow }" class="modal fade">
            <form @submit.prevent="submitFormData">
                <div class="modal-dialog modal-xl modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header border-bottom">
                            <h5 class="modal-title h4 text-capitalize">
                                {{ (sectionID ? $t('header.edit') : $t('header.add')) + 'Section' }}
                                <small v-if="sectionID" class="m-0 text-muted">Section - {{ name }}"</small>
                            </h5>
                            <button type="button" class="close" @click="modalShow = false">
                                <span aria-hidden="true"><i class="fal fa-times"></i></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="tab-content">
                                <div class="row">
                                    <div class="col-sm-12 border-right">
                                        <div class="form-group">
                                            <label class="form-label">{{ $t('label.title') }}</label>
                                            <div class="input-group bg-white shadow-inset-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text bg-transparent border-right-0">
                                                        <i class="fas fa-text"></i>
                                                    </span>
                                                </div>
                                                <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')"
                                                    v-model="name"
                                                    required="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="row w-100 no-gutters">
                                <div class="col">
                                    <button
                                        v-if="sectionID && deletable"
                                        type="button"
                                        class="btn border-0 btn-danger btn-padding waves-effect waves-themed"
                                        @click="deleteServiceConfirm">
                                        Delete
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button
                                        type="button"
                                        class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3"
                                        @click="returnServiceList">
                                        {{ $t('button_link.cancel') }}
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button
                                        type="submit"
                                        class="btn border-0 btn-primary btn-padding waves-effect waves-themed">
                                        {{ $t('button_link.save') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div :class="{ 'show': modalDeleteShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        Confirm delete {{ name }}?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="modalDeleteShow = false">Cancel</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="deleteService">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <div :class="{ 'show': errorModalShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        <i class="fas fa-2x" :class="isError ? ['fa-exclamation-circle', 'text-danger'] : ['fa-check-circle', 'text-success']"></i>
                        <p class="ml-3 mb-0" :class="isError ? ['text-danger'] : ['text-dark']">{{ errorMessage }}</p>
                    </div>
                    <div class="modal-footer">
                        <button id="modalClose" type="button" class="btn btn-primary waves-effect waves-themed" @click="closePopupModal()">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import vueDropzone from "vue2-dropzone";
import { VueEditor } from "vue2-editor";
import VueTimepicker from 'vue2-timepicker'
import { setCategoryLabel, getCategoryText, getSubcategory, handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { convertToMin, formFormatTime, isNumber, getMessage } from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'sectionForm',
    props: {
    },
    components: {
    },
    data() {
        return {
            modalShow: false,
            isSpinnerShow: true,

            typeID: 1,
            sectionID: 0,
            name: "",
            deletable: false,

            modalDeleteShow: false,

            errorModalShow: false,
            isError: true,
            errorMessage: '',
        }
    },
    methods: {
        showAddModal() {
            this.sectionID = null
            this.name = ''
            this.deletable = false

            this.isSpinnerShow = false

            this.modalShow = true
        },

        async showEditModal(item) {
            this.sectionID = item.sectionID;
            this.name = item.name;
            this.deletable = item.deletable

            this.modalShow = true
        },
        closeModal(isError) {
        },
        onServiceChange() {
            this.modalShow = false
            this.$emit('onServiceChange');
        },
        onServiceAddOrEdit() {
            this.modalShow = false
            this.$emit('onServiceAddOrEdit');
        },

        returnServiceList() {
            this.modalShow = false
            this.$emit('returnServiceList');
        },

        submitFormData() {
            var data = this.setFormData()
            this.submitForm(data, true, false)
        },
        setFormData() {
            var data = {}

            data['typeID'] = this.typeID
            data['sectionID'] = this.sectionID
            data['name'] = this.name

            return data
        },
        async submitForm(data) {
            let url
            if(this.sectionID) {
                url = `https://menu.tunai.io/business/sections/${this.sectionID}/update`
            } else {
                delete data['sectionID']
                url = `https://menu.tunai.io/business/sections/`
            }

            this.$axios({
                method: 'post',
                url: url,
                headers: { token: this.$util.getSessionToken() },
                data: data,
            })
                .then((response) => {
                    if (response.status == 200) {
                        var action = this.sectionID ? this.$i18n.t('message.success.action.update') : this.$i18n.t('message.success.action.add')
                        var retData = response.data;
                        var message = data['name'] + "' " + this.$i18n.t('message.success.success', { 'action': action })
                        this.$parent.$parent.$parent.setModal(this, false, true, message);

                        this.modalShow = false
                        this.onServiceAddOrEdit()
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                        this.errorModalShow = true
                        this.errorMessage = this.$i18n.t('message.error.system_error')
                    }
                })
        },
        closePopupModal() {
            this.errorModalShow = false
        },

        deleteServiceConfirm() {
            this.modalDeleteShow = true
        },
        deleteService() {
            let url = `https://menu.tunai.io/business/sections/${this.sectionID}/delete`

            this.$axios({
                method: 'post',
                url: url,
                headers: { token: this.$util.getSessionToken() },
            })
                .then((response) => {
                    if (response.status == 200) {
                        var message = 'Successfully remove ' + this.name
                        this.$parent.$parent.$parent.setModal(this, false, true, message);

                        this.modalDeleteShow = false
                        this.modalShow = false
                        this.onServiceAddOrEdit()
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                        this.modalErrorShow = true
                        this.errorMessage = this.$i18n.t('message.error.system_error')
                    }
                })
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.show {
    display: block;
}

.nav-link,
.link {
    cursor: pointer;
}

.img-thumbnail {
    width: 20em;
}

.item-image {
    width: 8em;
    opacity: .5;
}

.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>